import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=e26b739a&"
import script from "./Handle.vue?vue&type=script&lang=ts&"
export * from "./Handle.vue?vue&type=script&lang=ts&"
import style0 from "./Handle.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

component.options.__file = "Handle.vue"
export default component.exports